import { Box } from '@mui/material';
import { FC } from 'react';
import { useSnapshot } from 'valtio';
import { splitLongNames } from 'string-utils';
import CollapsiblePanel from '../../../elements/CollapsiblePanel/CollapsiblePanel';
import FiltersHeader from '../../../elements/FilterBox/FiltersHeader';
import {
  handleChangePipelineFilterSlider,
  onChangePipelinesFilter,
} from '../actions/pipeline-filter-issues-actions';
import IssuesSidebar from '../../common/components/IssuesSidebar/IssuesSidebar';
import config from '../../common/config/issues-config.json';
import {
  clearPipelineFilters,
  setSliderValuePriority,
  toggleFiltersPanel,
} from '../store-actions/pipeline-issues-store-actions';
import PipelineIssuesStore from '../stores/pipeline-issues-store';
import ResolvedIssuesSummaryContainer from './PipelineIssuesSummaryContainer';
import { pipelineIssuesFilters } from '../../common/utils/issue-utils';
import { handleSearchFilterTypePipeline } from '../actions/pipeline-issues-actions';

const ResolvedIssuesSidebarContainer: FC<
  React.PropsWithChildren<unknown>
> = () => {
  const {
    filtersOpen,
    sliderValuePriority,
    issuesFiltersType,
    issuesFiltersTypeSearch,
    numberOfFilters,
    filterIssuesBy,
    loadingFilters,
    totalIssues,
    searchValues,
  } = useSnapshot(PipelineIssuesStore);

  return (
    <CollapsiblePanel
      in={filtersOpen}
      collapsedSize={config.sidebar.collapsedSize}
      togglePanel={toggleFiltersPanel}>
      <IssuesSidebar
        searchValues={searchValues}
        handleSearchFilterType={handleSearchFilterTypePipeline}
        issuesFilters={pipelineIssuesFilters}
        totalIssues={totalIssues}
        issuesFiltersTypeSearch={issuesFiltersTypeSearch}
        issuesFiltersType={issuesFiltersType}
        filterList={filterIssuesBy}
        setSliderValuePriority={setSliderValuePriority}
        sliderValuePriority={sliderValuePriority}
        loadingFilters={loadingFilters}
        onChangeFilter={onChangePipelinesFilter}
        onChangeSliderFilter={handleChangePipelineFilterSlider}>
        <ResolvedIssuesSummaryContainer />
        {totalIssues > 0 && (
          <Box py={1}>
            <FiltersHeader
              numberOfFilters={numberOfFilters}
              filterIssuesBy={filterIssuesBy}
              onResetFilters={clearPipelineFilters}
              splitFilterTypeName={splitLongNames}
            />
          </Box>
        )}
      </IssuesSidebar>
    </CollapsiblePanel>
  );
};

export default ResolvedIssuesSidebarContainer;
